module.exports = __webpack_public_path__ + "img/star.37c89b8c.svg";